import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Paragraph } from '@digdir/designsystemet-react';

/**
 * Who follows up as safety representative, and why, when the team leader also represents the team: they cannot follow
 * up their own work, so the main safety representative does (arbeidsmiljøloven § 6-2).
 */
export const TakenOverNotice = ({ emails }: { emails: string[] | null | undefined }): ReactElement | null => {
  const { t } = useTranslation();
  if (!emails || emails.length === 0) return null;
  return (
    <Paragraph data-size="sm" data-color="subtle">
      {t('workEnvironmentRisk.takenOver', { emails: emails.join(', '), count: emails.length })}
    </Paragraph>
  );
};
